
export const backStaticRoutes = [
    {
        path: '/operations/group',
        name: 'OperationsGroup',
        component: () => import('/@/views/productOperations/subscription/group.vue'),
        meta: {
            title: '集团订阅信息',
            isLink: '',
            isHide: true,
            isKeepAlive: false,
            isAffix: false,
            isIframe: false,
            roles: ['admin']
        }
    },
    {
        path: '/operations/merchant',
        name: 'OperationsMerchant',
        component: () => import('/@/views/productOperations/subscription/merchant.vue'),
        meta: {
            title: '机构订阅信息',
            isLink: '',
            isHide: true,
            isKeepAlive: false,
            isAffix: false,
            isIframe: false,
            roles: ['admin']
        }
    },
    {
        path: '/operations/add',
        name: 'OperationsAdd',
        component: () => import('/@/views/productOperations/subscription/add.vue'),
        meta: {
            title: '添加订阅信息',
            isLink: '',
            isHide: true,
            isKeepAlive: false,
            isAffix: false,
            isIframe: false,
            roles: ['admin']
        }
    },
    {
        path: '/inventory/group',
        name: 'InventoryGroup',
        component: () => import('/@/views/productOperations/inventory/group.vue'),
        meta: {
            title: '集团库存信息',
            isLink: '',
            isHide: true,
            isKeepAlive: false,
            isAffix: false,
            isIframe: false,
            roles: ['admin']
        }
    },
    {
        path: '/inventory/merchant',
        name: 'InventoryMerchant',
        component: () => import('/@/views/productOperations/inventory/merchant.vue'),
        meta: {
            title: '机构库存信息',
            isLink: '',
            isHide: true,
            isKeepAlive: false,
            isAffix: false,
            isIframe: false,
            roles: ['admin']
        }
    },
    {
        path: '/inventory/add',
        name: 'InventoryAdd',
        component: () => import('/@/views/productOperations/inventory/add.vue'),
        meta: {
            title: '添加库存信息',
            isLink: '',
            isHide: true,
            isKeepAlive: false,
            isAffix: false,
            isIframe: false,
            roles: ['admin']
        }
    },
   {
				path: '/agent/agentInventory',
				name: 'agentInventory',
				component: () => import('/@/views/agentInventory/index.vue'),
				meta: {
					title: '经销商库存',
					isLink: '',
					isHide: true,
					isKeepAlive: false,
					isAffix: false,
					isIframe: false,
					roles: ['admin']
				}
			}
]
